<template>
    <div>
        <!-- >>> Begin:Upper Banner -->
        <div class="banner imagebg-container" style="height: 350px; background-image: url(/res/images/group-booking/groupbooking-banner.jpg);">
            <div class="container">
            <h1 class="big-caption">{{ bannerline1[getCurrentLocale] }} <em>{{ now[getCurrentLocale] }}</em></h1>
            <h2 class="med-caption yellow-color">{{ bannerline2[getCurrentLocale] }}</h2>
            </div>
        </div>
        <!-- <<< End:Upper Banner -->


        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin: Page  -->
                    <div id="main" class="col-md-9" v-show="sentSuccessful === false">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />


                        <div class="sdr-box booking-section">
                            <h3>{{ welcome[getCurrentLocale] }}</h3>
                            <p v-html="welcometext1[getCurrentLocale]"></p>
                            <!-- <br /><br />
                            <p v-html="welcometext2[getCurrentLocale]"></p> -->
                        </div>


                        <br/>


                        <div class="sdr-box booking-section">
                            <form @submit.prevent="onSubmit">

                                <div>
                                    <h2>{{ groupbooking[getCurrentLocale] }}:</h2>
                                    <h4>{{ request[getCurrentLocale] }}:</h4><br />

                                    <div class="form-group row choose-travel">
                                        <div class="col-xs-12 col-md-5 constant-column-2">
                                            <div>
                                                <label class="radio radio-inline" style="margin-left: 0px;">
                                                    <input type="radio" name="choose-travel" value="1" v-on:change="outwardonly = false" checked>{{ outwardandreturnflight[getCurrentLocale] }}
                                                </label>
                                            </div>
                                            <div>
                                                <label class="radio radio-inline">
                                                    <input type="radio" name="choose-travel" value="2" v-on:change="outwardonly = true">{{ outwardonlyflight[getCurrentLocale] }}
                                                </label>
                                            </div>
                                        </div>
                                    </div><br />

                                    <!-- >>> row: departureairport, destinationairport -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_departureairport[getCurrentLocale] }}:*</label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_departureairport.$error }"
                                                @input="$v.inputGroupbooking_departureairport.$touch()"
                                                v-model="inputGroupbooking_departureairport"
                                                id="inputGroupbooking_departureairport"
                                                name="inputGroupbooking_departureairport"
                                                :placeholder="placeholder_departureairport[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', departureairport -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_departureairport.$dirty && !$v.inputGroupbooking_departureairport.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', departureairport -->
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_destinationairport[getCurrentLocale] }}:*</label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_destinationairport.$error }"
                                                @input="$v.inputGroupbooking_destinationairport.$touch()"
                                                v-model="inputGroupbooking_destinationairport"
                                                id="inputGroupbooking_destinationairport"
                                                name="inputGroupbooking_destinationairport"
                                                :placeholder="placeholder_destinationairport[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', destinationairport -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_destinationairport.$dirty && !$v.inputGroupbooking_destinationairport.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', destinationairport -->
                                        </div>
                                    </div>
                                    <!-- <<< row: departureairport, destinationairport -->

                                    <!-- >>> row: departuredate, destinationdate -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_departuredate[getCurrentLocale] }}:*</label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_departuredate.$error }"
                                                @input="$v.inputGroupbooking_departuredate.$touch()"
                                                v-model="inputGroupbooking_departuredate"
                                                id="inputGroupbooking_departuredate"
                                                name="inputGroupbooking_departuredate"
                                                :placeholder="placeholder_departuredate[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', departuredate -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_departuredate.$dirty && !$v.inputGroupbooking_departuredate.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', departuredate -->
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label v-show="outwardonly === false">{{ label_destinationdate[getCurrentLocale] }}:*</label>
                                            <input  v-show="outwardonly === false" type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_destinationdate.$error }"
                                                @input="$v.inputGroupbooking_destinationdate.$touch()"
                                                v-model="inputGroupbooking_destinationdate"
                                                id="inputGroupbooking_destinationdate"
                                                name="inputGroupbooking_destinationdate"
                                                :placeholder="placeholder_destinationdate[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', destinationdate -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_destinationdate.$dirty && !$v.inputGroupbooking_destinationdate.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', destinationdate -->
                                        </div>
                                    </div>
                                    <!-- <<< row: departuredate, destinationdate -->

                                    <!-- >>> row: adultschildscount, infantscount -->
                                    <div class="form-group row">
                                        <div class="col-xs-12 col-md-5 constant-column-2">
                                            <div>
                                                <label>{{ label_adultschilds[getCurrentLocale] }}:*</label>
                                                <div class="selector">
                                                    <select class="full-width" id="inputGroupbooking_adultschildscount" name="inputGroupbooking_adultschildscount">
                                                        <option v-for="adultsCount in range(10, 174)" v-bind:value="adultsCount" v-bind:key="adultsCount">{{ adultsCount }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div>
                                                <label>{{ label_infants[getCurrentLocale] }}:*</label>
                                                <input type="text" class="input-text full-width"
                                                    :class="{ invalid : $v.inputGroupbooking_infantscount.$error }"
                                                    @input="$v.inputGroupbooking_infantscount.$touch()"
                                                    v-model="inputGroupbooking_infantscount"
                                                    id="inputGroupbooking_infantscount"
                                                    name="inputGroupbooking_infantscount"
                                                    placeholder="" />
                                            <!-- >>> 'errormsg', departureairport -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_infantscount.$dirty && !$v.inputGroupbooking_infantscount.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', departureairport -->
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <<< row: adultschildscount, infantscount -->
                                </div>


                                <!-- ------------------------------------------- -->
                                <!-- ------------------------------------------- -->
                                <hr />
                                <!-- ------------------------------------------- -->
                                <!-- ------------------------------------------- -->


                                <div>
                                    <h2>{{ groupdetails[getCurrentLocale] }}:</h2>
                                    <!-- >>> row: groupname -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_groupname[getCurrentLocale] }}:</label>
                                            <input type="text" class="input-text full-width"
                                                id="inputGroupbooking_groupname"
                                                name="inputGroupbooking_groupname"
                                                :placeholder="placeholder_groupname[getCurrentLocale]" />
                                        </div>
                                    </div>
                                    <!-- <<< row: groupname -->

                                    <!-- >>> row: street, streetno (val:ok) -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_street[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_street.$error }"
                                                @input="$v.inputGroupbooking_street.$touch()"
                                                v-model="inputGroupbooking_street"
                                                id="inputGroupbooking_street"
                                                name="inputGroupbooking_street"
                                                :placeholder="placeholder_street[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', street -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_street.$dirty && !$v.inputGroupbooking_street.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', street -->
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_streetno[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_streetno.$error }"
                                                @input="$v.inputGroupbooking_streetno.$touch()"
                                                v-model="inputGroupbooking_streetno"
                                                id="inputGroupbooking_streetno"
                                                name="inputGroupbooking_streetno"
                                                :placeholder="placeholder_streetno[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', streetno -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_streetno.$dirty && !$v.inputGroupbooking_streetno.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', streetno -->
                                        </div>
                                    </div>
                                    <!-- <<< row: street, streetno (val:ok) -->

                                    <!-- >>> row: zip, place (val:ok) -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_zip[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_zip.$error }"
                                                @input="$v.inputGroupbooking_zip.$touch()"
                                                v-model="inputGroupbooking_zip"
                                                id="inputGroupbooking_zip"
                                                name="inputGroupbooking_zip"
                                                :placeholder="placeholder_zip[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', zip -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_zip.$dirty && !$v.inputGroupbooking_zip.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_zip.$dirty && !$v.inputGroupbooking_zip.numeric">{{ errmsg_numeric[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_zip.$dirty && !$v.inputGroupbooking_zip.minLength">{{ errmsg_min_plz[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_zip.$dirty && !$v.inputGroupbooking_zip.maxLength">{{ errmsg_max_plz[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', zip -->
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_place[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_place.$error }"
                                                @input="$v.inputGroupbooking_place.$touch()"
                                                v-model="inputGroupbooking_place"
                                                id="inputGroupbooking_place"
                                                name="inputGroupbooking_place"
                                                :placeholder="placeholder_place[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', place -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_place.$dirty && !$v.inputGroupbooking_place.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_place.$dirty && !$v.inputGroupbooking_place.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_place.$dirty && !$v.inputGroupbooking_place.minLength">{{ errmsg_min_residence[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_place.$dirty && !$v.inputGroupbooking_place.maxLength">{{ errmsg_max_residence[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', place -->
                                        </div>
                                    </div>
                                    <!-- <<< row: zip, place (val:ok) -->

                                    <!-- >>> row: country -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_country[getCurrentLocale] }}:</label>
                                            <input type="text" class="input-text full-width"
                                                id="inputGroupbooking_country"
                                                name="inputGroupbooking_country"
                                                :placeholder="placeholder_country[getCurrentLocale]" />
                                        </div>
                                    </div>
                                    <!-- <<< row: country -->
                                </div>


                                <hr>


                                <div>
                                    <h2>{{ contactfor[getCurrentLocale] }}:</h2>
                                    <!-- >>> row: firstname (val:ok) -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_salutation[getCurrentLocale] }}:</label>
                                            <input type="text" class="input-text full-width"
                                                id="inputGroupbooking_salutation"
                                                name="inputGroupbooking_salutation"
                                                :placeholder="placeholder_salutation[getCurrentLocale]" />
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_firstname[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_firstname.$error }"
                                                @input="$v.inputGroupbooking_firstname.$touch()"
                                                v-model="inputGroupbooking_firstname"
                                                id="inputGroupbooking_firstname"
                                                name="inputGroupbooking_firstname"
                                                :placeholder="placeholder_firstname[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', firstname -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_firstname.$dirty && !$v.inputGroupbooking_firstname.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_firstname.$dirty && !$v.inputGroupbooking_firstname.minLength">{{ errmsg_min_firstname[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_firstname.$dirty && !$v.inputGroupbooking_firstname.maxLength">{{ errmsg_max_firstname[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_firstname.$dirty && !$v.inputGroupbooking_firstname.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', firstname -->
                                        </div>
                                    </div>
                                    <!-- <<< row: firstname (val:ok) -->

                                    <!-- >>> row: lastname, phone (val:ok) -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_lastname[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_lastname.$error }"
                                                @input="$v.inputGroupbooking_lastname.$touch()"
                                                v-model="inputGroupbooking_lastname"
                                                id="inputGroupbooking_lastname"
                                                name="inputGroupbooking_lastname"
                                                :placeholder="placeholder_lastname[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', lastname -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_lastname.$dirty && !$v.inputGroupbooking_lastname.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_lastname.$dirty && !$v.inputGroupbooking_lastname.minLength">{{ errmsg_min_firstname[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_lastname.$dirty && !$v.inputGroupbooking_lastname.maxLength">{{ errmsg_max_firstname[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_lastname.$dirty && !$v.inputGroupbooking_lastname.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', lastname -->
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_phone[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_phone.$error }"
                                                @input="$v.inputGroupbooking_phone.$touch()"
                                                v-model="inputGroupbooking_phone"
                                                id="inputGroupbooking_phone"
                                                name="inputGroupbooking_phone"
                                                :placeholder="placeholder_phone[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', phone -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_phone.$dirty && !$v.inputGroupbooking_phone.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_phone.$dirty && !$v.inputGroupbooking_phone.numericspaces">{{ errmsg_numericspaces[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_phone.$dirty && !$v.inputGroupbooking_phone.minLength">{{ errmsg_min_phone[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="$v.inputGroupbooking_phone.$dirty && !$v.inputGroupbooking_phone.maxLength">{{ errmsg_max_phone[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', phone -->
                                        </div>
                                    </div>
                                    <!-- <<< row: lastname, phone (val:ok) -->

                                    <!-- >>> row: mobile, fax -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_mobile[getCurrentLocale] }}:</label>
                                            <input type="text" class="input-text full-width"
                                                id="inputGroupbooking_mobile"
                                                name="inputGroupbooking_mobile"
                                                :placeholder="placeholder_mobile[getCurrentLocale]" />
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_fax[getCurrentLocale] }}:</label>
                                            <input type="text" class="input-text full-width"
                                                id="inputGroupbooking_fax"
                                                name="inputGroupbooking_fax"
                                                :placeholder="placeholder_fax[getCurrentLocale]" />
                                        </div>
                                    </div>
                                    <!-- <<< row: mobile, fax -->

                                    <!-- >>> row: email, emailrepeat (val:ok) -->
                                    <div class="form-group row">
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_email[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_email.$error }"
                                                @input="$v.inputGroupbooking_email.$touch()"
                                                v-model="inputGroupbooking_email"
                                                id="inputGroupbooking_email"
                                                name="inputGroupbooking_email"
                                                :placeholder="placeholder_email[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', email -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_email.$dirty && !$v.inputGroupbooking_email.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="!$v.inputGroupbooking_email.email">{{ errmsg_email[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', email -->
                                        </div>
                                        <div class="col-sm-6 col-md-5">
                                            <label>{{ label_emailrepeat[getCurrentLocale] }}:*<small></small></label>
                                            <input type="text" class="input-text full-width"
                                                :class="{ invalid : $v.inputGroupbooking_emailrepeat.$error }"
                                                @input="$v.inputGroupbooking_emailrepeat.$touch()"
                                                v-model="inputGroupbooking_emailrepeat"
                                                id="inputGroupbooking_emailrepeat"
                                                name="inputGroupbooking_emailrepeat"
                                                :placeholder="placeholder_emailrepeat[getCurrentLocale]" />
                                            <!-- >>> 'errormsg', emailrepeat -->
                                            <p class="errormsg" v-if="$v.inputGroupbooking_emailrepeat.$dirty && !$v.inputGroupbooking_emailrepeat.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                            <p class="errormsg" v-if="!$v.inputGroupbooking_emailrepeat.email">{{ errmsg_email[getCurrentLocale] }}</p>
                                            <!-- <<< 'errormsg', emailrepeat -->
                                        </div>
                                    </div>
                                    <!-- <<< row: email, emailrepeat (val:ok) -->

                                    <!-- >>> row: remark -->
                                    <div class="form-group row">
                                        <div class="col-md-10">
                                            <label>{{ label_remark[getCurrentLocale] }}</label>
                                            <textarea class="full-width" rows="10" id="inputGroupbooking_remark" name="inputGroupbooking_remark" :placeholder="placeholder_remark[getCurrentLocale]"></textarea>
                                        </div>
                                    </div>
                                    <!-- <<< row: remark -->
                                </div>


                                <hr>


                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <a class="button btn-large uppercase full-width silver" v-if="!vldt_Form_Groups()">{{ send_request[getCurrentLocale] }}</a>
                                        <button type="submit" class="btn-large icon-check uppercase full-width" v-if="vldt_Form_Groups()">{{ send_request[getCurrentLocale] }}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div id="main" class="col-sm-8 col-md-9" v-show="sentSuccessful === true">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ wasssentsuccesful[getCurrentLocale] }}</h1>
                        </div>
                    </div>
                    <!-- End: Page -->


                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { helpers, required, minLength, maxLength, numeric, alphaNum, email } from 'vuelidate/lib/validators';
    const letterspaces = helpers.regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i);    /* Validator */
    const numericspaces = helpers.regex('numericspaces', /^[0-9+/\s]+$/i);       /* Validator */

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import axios from 'axios';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                bannerline1: {
                    en: 'Group Booking?',
                    de: 'Gruppenbuchung?',
                },
                now: {
                    en: 'With pleasure!',
                    de: 'Sehr gern!',
                },
                bannerline2: {
                    en: 'Make your request.',
                    de: 'Stellen Sie Ihre Anfrage.',
                },
                // >>> ------------------------
                titleinfo: {
                    en: 'Group Booking',
                    de: 'Gruppenbuchung',
                },
                wasssentsuccesful : {
                    en: 'Successfully sent!',
                    de: 'Erfolgreich gesendet!',
                },
                welcome: {
                    en: 'Welcome to the SUNDAIR Group Department',
                    de: 'Herzlich Willkommen bei der SUNDAIR Gruppenabteilung',
                },
                welcometext1: {
                    en: 'Dear passenger,<br /><br />thank you very much for your interest in booking your group on one of our flights.<br /><br />Groups should have a minimum size of 10 persons.<br />Please fill out the form below. We will get in touch with you as soon as possible.<br /><br />We look forward to welcoming you on board soon.',
                    de: 'Sehr geehrter Fluggast,<br /><br />vielen Dank für Ihr Interesse, Ihre Gruppe auf einem unserer Flüge buchen zu wollen.<br /><br />Gruppen sollten eine Mindestgröße von 10 Personen haben.<br />Bitte füllen Sie das nachfolgende Formular aus. Wir werden uns umgehend mit Ihnen in Verbindung setzen.<br /><br />Wir freuen uns, Sie bald bei uns an Bord begrüßen zu dürfen.',
                },
                welcometext2: {
                    en: 'Here we have summarized all group conditions for you:<br />Download conditions: <a href="https://www.sundair.com/downloads/Groupconditions.pdf" target="_blank" style="font-size:15.9996px; color: #D6254D;">here</a>',
                    de: 'Hier haben wir alle Gruppenkonditionen für Sie zusammengefasst:<br />Konditionen herunterladen: <a href="https://www.sundair.com/downloads/Gruppenkonditionen.pdf" target="_blank" style="font-size:15.9996px; color: #D6254D;">hier</a>',
                },

                // >>> ------------------------
                groupbooking: {
                    en: 'Group Booking',
                    de: 'Gruppenbuchung',
                },
                request: {
                    en: 'Make a non-binding request',
                    de: 'Stellen Sie eine unverbindliche Anfrage'
                },
                // >>> ------------------------
                // >>> ------------------------
                outwardandreturnflight: {
                    en: 'Round Trip',
                    de: 'Hin- und Rückflug',
                },
                outwardonlyflight: {
                    en: 'One Way Only',
                    de: 'nur Hinflug',
                },
                label_departureairport: {
                    en: 'Departure airport',
                    de: 'Abflughafen',
                },
                placeholder_departureairport: {
                    en: 'Please enter your departure airport',
                    de: 'Bitte Ihren Abflughafen eingeben',
                },
                label_destinationairport: {
                    en: 'Destination Airport',
                    de: 'Zielflugafen',
                },
                placeholder_destinationairport: {
                    en: 'Please enter your destination airport',
                    de: 'Bitte Ihren Zielflughafen eingeben',
                },
                label_departuredate: {
                    en: 'Departure Date',
                    de: 'Abflugdatum',
                },
                placeholder_departuredate: {
                    en: 'Please enter your departure date',
                    de: 'Bitte Ihr Abflugdatum eingeben',
                },
                label_destinationdate: {
                    en: 'Destination Date',
                    de: 'Rückflugdatum',
                },
                placeholder_destinationdate: {
                    en: 'Please enter your destination date',
                    de: 'Bitte Ihr Rückflugdatum eingeben',
                },
                label_adultschilds: {
                    en: 'Adults & Childs',
                    de: 'Erwachsene & Kinder',
                },
                label_infants: {
                    en: 'Number of babies',
                    de: 'Anzahl Babies',
                },
                // >>> ------------------------
                // >>> ------------------------
                groupdetails: {
                    en: 'Information on the group',
                    de: 'Angaben zur Gruppe',
                },
                label_groupname: {
                    en: 'Group name (e.g. company, club)',
                    de: 'Gruppenname (z.B. Unternehmen, Club)',
                },
                placeholder_groupname: {
                    en: 'Please enter your group name',
                    de: 'Bitte Ihre Gruppeninfo eingeben',
                },
                label_street: {
                    en: 'Street',
                    de: 'Strasse',
                },
                placeholder_street: {
                    en: 'Please enter your street',
                    de: 'Bitte Ihre Strasse eingeben',
                },
                label_streetno: {
                    en: 'Street number',
                    de: 'Nr.',
                },
                placeholder_streetno: {
                    en: 'Please enter your street number',
                    de: 'Bitte Ihre Hausnummer eingeben',
                },
                label_zip: {
                    en: 'ZIP Code',
                    de: 'PLZ',
                },
                placeholder_zip: {
                    en: 'Please enter your zip code',
                    de: 'Bitte Ihre PLZ eingeben',
                },
                label_place: {
                    en: 'Place',
                    de: 'Ort',
                },
                placeholder_place: {
                    en: 'Please enter your place',
                    de: 'Bitte Ihren Ort eingeben',
                },
                label_country: {
                    en: 'Country',
                    de: 'Land',
                },
                placeholder_country: {
                    en: 'Please enter your country',
                    de: 'Bitte Ihr Land eingeben',
                },
                // >>> ------------------------
                // >>> ------------------------
                contactfor: {
                    en: 'Contact for',
                    de: 'Ansprechpartner',
                },
                label_salutation: {
                    en: 'Salutation',
                    de: 'Anrede',
                },
                placeholder_salutation: {
                    en: 'Please enter your salutation',
                    de: 'Bitte Ihre Anrede eingeben',
                },
                label_firstname: {
                    en: 'First name',
                    de: 'Vorname',
                },
                placeholder_firstname: {
                    en: 'Please enter your first name',
                    de: 'Bitte Ihren Vornamen eingeben',
                },
                label_lastname: {
                    en: 'Last name',
                    de: 'Nachname',
                },
                placeholder_lastname: {
                    en: 'Please enter your last name',
                    de: 'Bitte Ihren Nachnamen eingeben',
                },
                label_phone: {
                    en: 'Phone',
                    de: 'Telefon',
                },
                placeholder_phone: {
                    en: 'Please enter your phone number',
                    de: 'Bitte Ihre Telefonnummer eingeben',
                },
                label_mobile: {
                    en: 'Mobile',
                    de: 'Mobile',
                },
                placeholder_mobile: {
                    en: 'Please enter your mobile number',
                    de: 'Bitte Ihre Handynummer eingeben',
                },
                label_fax: {
                    en: 'Fax',
                    de: 'Fax',
                },
                placeholder_fax: {
                    en: 'Please enter your fax number',
                    de: 'Bitte Ihre Faxnummer eingeben',
                },
                label_email: {
                    en: 'E-mail',
                    de: 'E-Mail',
                },
                placeholder_email: {
                    en: 'Please enter your e-mail',
                    de: 'Bitte Ihre E-Mail Adresse eingeben',
                },
                label_emailrepeat: {
                    en: 'E-mail (again)',
                    de: 'E-Mail (wiederh.)',
                },
               placeholder_emailrepeat: {
                    en: 'Please enter your e-mail',
                    de: 'Bitte Ihre E-Mail Adresse eingeben',
                },
                label_remark: {
                    en: 'Remark',
                    de: 'Bemerkung',
                },
                placeholder_remark: {
                    en: 'Remarks to SUNDAIR',
                    de: 'Bemerkungen an Sundair',
                },
                send_request: {
                    en: 'SEND REQUEST',
                    de: 'ANFRAGE SENDEN',
                },
                // >>> --------------------------
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                // >>> --------------------------
               errmsg_letterspaces: {
                    en: 'Letters, "-" and spaces are allowed.',
                    de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.',
                },
                // >>> --------------------------
                errmsg_numericspaces: {
                    en: 'Numbers, "+/" and spaces are allowed.',
                    de: 'Erlaubt sind Zahlen, “+/“ und Leerzeichen.',
                },
                // >>> --------------------------
               errmsg_numeric: {
                    en: 'Only numbers are allowed.',
                    de: 'Es sind nur Zahlen erlaubt.',
                },
                errmsg_alphanum: {
                    en: 'Only numbers and letters are allowed.',
                    de: 'Erlaubt sind nur Zahlen und Buchstaben.',
                },
                // >>> --------------------------
                errmsg_min_firstname : {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                errmsg_max_firstname: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_lastname : {
                    en: 'Allowed length: 2-60 characters.',
                    de: 'Erlaubte Länge: 2-60 Zeichen.',
                },
                errmsg_max_lastname: {
                    en: 'Allowed length: 2-60 characters.',
                    de: 'Erlaubte Länge: 2-60 Zeichen.',
                },
                // >>> --------------------------
                errmsg_email: {
                    en: 'Please provide valid E-mail.',
                    de: 'Bitte geben Sie eine gültige E-Mail an.',
                },
                // >>> --------------------------
                errmsg_min_plz : {
                    en: 'Allowed length: 4-8 characters.',
                    de: 'Erlaubte Länge: 4-8 Zeichen.',
                },
                errmsg_max_plz: {
                    en: 'Allowed length: 4-8 characters.',
                    de: 'Erlaubte Länge: 4-8 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_residence: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                errmsg_max_residence: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_phone: {
                    en: 'Allowed length: 5-18 characters.',
                    de: 'Erlaubte Länge: 5-18 Zeichen.',
                },
                errmsg_max_phone: {
                    en: 'Allowed length: 5-18 characters.',
                    de: 'Erlaubte Länge: 5-18 Zeichen.',
                },
                // >>> -------------------------- 'Form / Model / Vuelidate'
                inputGroupbooking_departureairport: '', // new:
                inputGroupbooking_destinationairport: '',
                inputGroupbooking_departuredate: '',
                inputGroupbooking_destinationdate: '',
                inputGroupbooking_adultschildscount: '',
                inputGroupbooking_infantscount: '',

                inputGroupbooking_groupname: '',
                inputGroupbooking_street: '', // ok
                inputGroupbooking_streetno: '', // ok
                inputGroupbooking_zip: '', // ok
                inputGroupbooking_place: '', // ok
                inputGroupbooking_country: '',

                inputGroupbooking_salutation: '',
                inputGroupbooking_firstname: '', // ok
                inputGroupbooking_lastname: '', // ok
                inputGroupbooking_phone: '', // ok
                inputGroupbooking_mobile: '',
                inputGroupbooking_fax: '',
                inputGroupbooking_email: '', // ok
                inputGroupbooking_emailrepeat: '', // ok
                // >>> --------------------------------------------------------- SearchForm
                outwardonly: false, // ReturnFlight too?
                sentSuccessful: false
            };

        }, // eof data()
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Validations */
        validations: {

            // >>> departureairport -------------
            inputGroupbooking_departureairport: {
                required: required,
            },
            // >>> destinationairport -----------
            inputGroupbooking_destinationairport: {
                required: required,
            },
            // >>> departuredate ----------------
            inputGroupbooking_departuredate: {
                required: required,
            },
            // >>> destinationdate --------------
            inputGroupbooking_destinationdate: {
                required: required,
            },
            // >>> infantscount -----------------
            inputGroupbooking_infantscount: {
                required: required,
            },




            // >>> street -----------------------
            inputGroupbooking_street: {
                required: required,
            },
            // >>> streetno -----------------------
            inputGroupbooking_streetno: {
                required: required,
            },
            // >>> zip --------------------------
            inputGroupbooking_zip: {
                required: required,
                numeric: numeric,
                minLength: minLength(4),
                maxLength: maxLength(8),
            },
            // >>> place ------------------------
            inputGroupbooking_place: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                letterspaces: letterspaces
            },

            // >>> firstname --------------------
            inputGroupbooking_firstname: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                letterspaces: letterspaces
            },
            // >>> lastname ---------------------
            inputGroupbooking_lastname: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(60),
                letterspaces: letterspaces
            },
            // >>> phone ------------------------
            inputGroupbooking_phone: {
                required: required,
                minLength: minLength(5),
                maxLength: maxLength(18),
                numericspaces: numericspaces
            },
            // >>> email ------------------------
            inputGroupbooking_email: {
                required: required,
                email: email,
            },
            // >>> emailrepeal ------------------
            inputGroupbooking_emailrepeat: {
                required: required,
                email: email,
            }

        }, // eof validations{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/humanresources/gruppenform' (PUT)
            *
            * Desc:  Saving 'Groups'.
            * Note:
            *
            * @param {Object} requestParamObject (Params to send)
            * @return
            */
            call_saveGroup(requestParamObject) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> /infos/group-booking/Home.vue >>> call_saveGroup');
                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/humanresources/gruppenform/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.$vp_um();
                                me.sentSuccessful = true;
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_saveGroup()





            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: Form gets submitted. Catch up Data.
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @return
            */
            onSubmit(submitEvent) {

                let me = this,
                    my_arrTimeLocal = null,
                    my_city = null,
                    my_comment = null,
                    my_companyName = null,
                    my_country = null,
                    my_depTimeLocal = null,
                    my_departure = null,
                    my_destination = null,
                    my_email = null,
                    my_email2 = null,
                    my_fax = null,
                    my_mobile = null,
                    my_name = null,
                    my_noADL = null,
                    my_noCHD = null,
                    my_noHours = null,
                    my_noINF = null,
                    my_phone = null,
                    my_salutation = null,
                    my_street = null,
                    my_streetNo = null,
                    my_surname = null,
                    my_zip = null,
                    requestParamObject = {};


                me.$toc('>>> /infos/group-booking/Home.vue >>> onSubmit');
                // >>> Build Object --------------------------------------------
                requestParamObject = {
                    "arrTimeLocal": submitEvent.target.elements['inputGroupbooking_destinationairport'].value,
                    "city": submitEvent.target.elements['inputGroupbooking_place'].value,
                    "comment": submitEvent.target.elements['inputGroupbooking_remark'].value,
                    "companyName": submitEvent.target.elements['inputGroupbooking_groupname'].value,
                    "country": submitEvent.target.elements['inputGroupbooking_country'].value,
                    "depTimeLocal": submitEvent.target.elements['inputGroupbooking_departuredate'].value,
                    "departure": submitEvent.target.elements['inputGroupbooking_departureairport'].value,
                    "destination": submitEvent.target.elements['inputGroupbooking_destinationairport'].value,
                    "email": submitEvent.target.elements['inputGroupbooking_email'].value,
                    "email2": submitEvent.target.elements['inputGroupbooking_emailrepeat'].value,
                    "fax": submitEvent.target.elements['inputGroupbooking_fax'].value,
                    "mobile": submitEvent.target.elements['inputGroupbooking_mobile'].value,
                    "name": submitEvent.target.elements['inputGroupbooking_firstname'].value,
                    "noADL": submitEvent.target.elements['inputGroupbooking_adultschildscount'].value !== '' ? Number(submitEvent.target.elements['inputGroupbooking_adultschildscount'].value) : null,
                    "noCHD": my_noCHD,
                    "noHours": my_noHours,
                    "noINF": submitEvent.target.elements['inputGroupbooking_infantscount'].value !== '' ? Number(submitEvent.target.elements['inputGroupbooking_infantscount'].value) : null,
                    "phone": submitEvent.target.elements['inputGroupbooking_phone'].value,
                    "salutation": submitEvent.target.elements['inputGroupbooking_salutation'].value,
                    "street": submitEvent.target.elements['inputGroupbooking_street'].value,
                    "streetNo": submitEvent.target.elements['inputGroupbooking_streetno'].value,
                    "surname": submitEvent.target.elements['inputGroupbooking_lastname'].value,
                    "zip":  submitEvent.target.elements['inputGroupbooking_zip'].value
                };

                if (requestParamObject !== '') {
                    this.call_saveGroup(requestParamObject)
                }

            }, // eof onSubmit()





            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * vldt_Form_Groups()
            *
            * Desc:
            * Note: If valid ... then Call ...
            *
            * @param
            * @return {Boolean}
            */
            vldt_Form_Groups: function() {

                var me = this,
                    formIsValid = true;


                me.$toc('>>> /infos/group-booking/Home.vue >>> vldt_Form_Groups');
                if (formIsValid) { // departureairport
                    if (me.$v.inputGroupbooking_departureairport.$dirty && !me.$v.inputGroupbooking_departureairport.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // destinationairport
                    if (me.$v.inputGroupbooking_destinationairport.$dirty && !me.$v.inputGroupbooking_destinationairport.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // departuredate
                    if (me.$v.inputGroupbooking_departuredate.$dirty && !me.$v.inputGroupbooking_departuredate.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if(!this.outwardonly) {
                    if (formIsValid) { // destinationdate
                        if (me.$v.inputGroupbooking_destinationdate.$dirty && !me.$v.inputGroupbooking_destinationdate.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                }
                if (formIsValid) { // infantscount
                    if (me.$v.inputGroupbooking_infantscount.$dirty && !me.$v.inputGroupbooking_infantscount.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }





                if (formIsValid) { // street
                    if (me.$v.inputGroupbooking_street.$dirty && !me.$v.inputGroupbooking_street.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // street
                    if (me.$v.inputGroupbooking_streetno.$dirty && !me.$v.inputGroupbooking_streetno.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // street
                    if (me.$v.inputGroupbooking_zip.$dirty && !me.$v.inputGroupbooking_zip.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // street
                    if (me.$v.inputGroupbooking_place.$dirty && !me.$v.inputGroupbooking_place.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }


                if (formIsValid) { // firstname
                    if (me.$v.inputGroupbooking_firstname.$dirty && !me.$v.inputGroupbooking_firstname.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // lastname
                    if (me.$v.inputGroupbooking_lastname.$dirty && !me.$v.inputGroupbooking_lastname.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // phone
                    if (me.$v.inputGroupbooking_phone.$dirty && !me.$v.inputGroupbooking_phone.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // email
                    if (me.$v.inputGroupbooking_email.$dirty && !me.$v.inputGroupbooking_email.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) { // emailrepeat
                    if (me.$v.inputGroupbooking_emailrepeat.$dirty && !me.$v.inputGroupbooking_emailrepeat.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }





                return formIsValid;

            }, // eof vldt_Form_Groups()

            /*******************************************************************
            * range()
            *
            * Desc: Builds Array for 'adultschildscount' Loop.
            * Note:
            *
            * @param min
            * @param max
            * @return {Array}
            */
            range: function(min,max){

                var array = [],
                    j = 0;


                for(var i = min; i <= max; i++){
                    array[j] = i;
                    j++;
                }

                return array;

            }, // eof range()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .radio input[type="radio"] {
        filter: alpha(opacity=1);
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)";
        -moz-opacity: 1;
        -khtml-opacity: 1;
        opacity: 1
    }


    .selector select {
        opacity: 1;
    }

    input:focus {
        outline: none;
    }
    input.input-text:focus, textarea:focus, .selector select:focus + .custom-select {
        outline: none;
        border: 1px solid #d3e4f7;
        box-shadow: 0 0 8px #d3e4f7;
    }

    input.input-text.invalid {
        border: 1px solid red;
        background-color: #fdecf8;
    }
    .selector select.invalid {
        border: 1px solid red;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }





    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-section {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/group-booking/Home.vue